import { useEffect, useState } from "react";
import { getPassages } from "../../services/passageService";

// Whether the server has the passages API (an old backend answers 404). A success is kept for the session,
// so passage controls do not pop in again on every visit; a failure is probed again on the next mount.
// Every component asking at once waits for the same request.
let passagesAvailable = false;
let probe = null;

export const markPassagesAvailable = () => {
  passagesAvailable = true;
};

const probeOnce = () => {
  if (!probe) {
    probe = getPassages({ params: { page_size: 1 } }).then(
      () => {
        markPassagesAvailable();
        return true;
      },
      () => {
        probe = null;
        return false;
      }
    );
  }
  return probe;
};

export default function usePassagesAvailable() {
  const [available, setAvailable] = useState(passagesAvailable);
  useEffect(() => {
    // The answer may have come between this component's first render and this effect.
    if (passagesAvailable) {
      setAvailable(true);
      return undefined;
    }
    let active = true;
    probeOnce().then((ok) => {
      if (active && ok) setAvailable(true);
    });
    return () => {
      active = false;
    };
  }, []);
  return available;
}
